import React from "react";
import { SEO, MarkdownContent, DynamicScript } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";

export default class PaymentPlansPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <Grid
          className={"custom-page-payment-plans custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row className={""} style={{ padding: 16 }} columns={1}>
            <Grid.Column
              className={""}
              style={{ padding: 16 }}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "37da2678-2293-4dab-9988-ec9c215ae57f",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className={""} style={{ padding: 16 }} columns={1}>
            <Grid.Column className={""} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__a87305ba-9247-48dc-a806-79a1f89b7d91"}
                >
                  <div>
                    <DynamicScript
                      type={"application/javascript"}
                      delay={200}
                      body={
                        "(function (w, d, s, o, f, js, fjs) {w[o] =w[o] ||function () {(w[o].q = w[o].q || []).push(arguments);};(js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);js.id = o;js.src = f;js.async = 1;fjs.parentNode.insertBefore(js, fjs);})(window, document, 'script', '_hw', ' https://files.withcherry.com/widgets/widget.js');_hw('init',{debug: false,variables: {slug: 'rejuvenexwellnessmedspa',name: 'Rejuvenex Wellness Medspa',},styles: {primaryColor: '#00c37d',secondaryColor: '#00c37d10',fontFamily: 'Lato',},},['all', 'hero', 'howitworks', 'testimony', 'faq', 'calculator']);"
                      }
                    />
                    <div id={"all"} />
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 24325 }) {
      title
      description
      components {
        files {
          file
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
  }
`;
